import { Rect } from '../../../platform/geom/Rect';
import { Colors } from '../../../ui';
import { TextRuler } from '../../canvas/visualization/TextRuler';
import { TagTextSettings } from '../annotations/TagLayout';
import { FlexLayout } from '../autoLayout/FlexLayout';
import { Assignable } from './Assignable';
import { TaskRecordAttr } from './TaskAssocations';

const opts = {
    open: { label: 'TO DO', color: Colors.gray200 },
    done: { label: 'DONE', color: Colors.positive },
    closed: { label: 'WON\'T DO', color: Colors.rose800 },
    deleted: { label: 'DELETED', color: Colors.gray200 },
};

export const TaskLayout = (base: Rect, assignable: Assignable) => {
    const record = TaskRecordAttr.get(assignable);
    if (!record) return null;

    const opt = opts[record.status] || opts.open;

    const { w: labelWidth } = TextRuler.measureSize(opt.label, TagTextSettings);

    const maxFrame = new Rect(
        base.left + 5,
        base.bottom - 18 - 5,
        base.width - 10,
        18,
    );

    const rects = FlexLayout.layoutRects(
        maxFrame,
        ['row', 'center', 'start', 3],
        [
            new Rect(0, 0, 18, 18),
            new Rect(0, 0, labelWidth + 7, 18),
        ]
    );

    const frame = Rect.fromMany(rects);

    const user = {
        area: rects[0],
        userId: record.userId,
    };

    const toggle = {
        area: rects[1],
        ...(opt as { label: string, color: string }),
        status: record.status,
    };

    return {
        frame,
        toggle,
        user,
    };
};

export type TaskLayout = ReturnType<typeof TaskLayout>;

